import React from "react";
import { usePartners } from "@/lib/partners";

// PartnerSelector — controls the Itinerary.partner field. Options come from
// the live "Partners" list (Trabajo → Partners; admins/agents with permission).
// Hidden partners stay out of the dropdown UNLESS the current itinerary still
// uses one — then we keep it visible so the select never goes blank.
export function PartnerSelector({ itn, setField }) {
  const { options, defaultKey } = usePartners();
  const current = itn.partner || "";
  const visible = options.filter((p) => !p.hidden || p.value === current);
  return (
    <select
      data-testid="itin-partner"
      value={current || defaultKey}
      onChange={(e) => setField("partner", e.target.value)}
      className="w-full bg-transparent outline-none text-sm cursor-pointer"
      title="Partner del cliente · su comisión y markup por defecto se aplican con ↻ Auto"
    >
      {visible.map((p) => (
        <option key={p.value} value={p.value}>{p.label} — {p.hint}</option>
      ))}
    </select>
  );
}
